import { PaymentCardImageTypes } from '../PaymentCardImageTypes';

import amex from './amex.png';
import bancomat from './bancomat.png';
import bc from './bc.png';
import dankort from './dankort.png';
import dinersclub from './dinersclub.png';
import discover from './discover.png';
import generic from './generic.png';
import giro from './giro.png';
import jcb from './jcb.png';
import maestro from './maestro.png';
import mastercard from './mastercard.png';
import mir from './mir.png';
import postfinance from './postfinance.png';
import rupay from './rupay.png';
import troy from './troy.png';
import unionpay from './unionpay.png';
import verve from './verve.png';
import visa from './visa.png';
import vpay from './vpay.png';

const paymentCards: PaymentCardImageTypes = {
    amex,
    bancomat,
    bc,
    dankort,
    dinersclub,
    discover,
    generic,
    giro,
    jcb,
    maestro,
    mastercard,
    mir,
    postfinance,
    rupay,
    troy,
    unionpay,
    verve,
    visa,
    vpay,
};

export default paymentCards;

export * as paymentCardsSvgComponent from './iconsSvgComponent';
export * as paymentCardsSvgString from './iconsSvgString';
